export default __webpack_public_path__ + "static/Oliwia z Dziadkiem-d6f72b06022ed3d136288859bb314bc2.png";